<mat-dialog-content id="share-modal">
  <div class="modal-content">
    <div class="modal-header p-0 mb-3">
      <h2 class="modal-title unbold">
        {{ data?.title || ('compartir' | translate) }}
      </h2>
      <button
        type="button"
        class="dismiss-modal border-0 bg-transparent"
        aria-label="Cerrar"
        (click)="dialogRef.close()"
      >
        X
      </button>
    </div>
    <div class="modal-body p-0">
      <div class="form-group d-flex mb-3" style="height: 34px">
        <input
          type="text"
          name=""
          id=""
          disabled
          [value]="url()"
          class="form-control rounded-3 rounded-end-0 border-end-0 h-100 dark-blue-text"
        />
        <button
          type="button"
          class="dark-blue rounded-3 rounded-start-0 h-100 py-1 px-2 px-md-4 fw-normal"
          ngbTooltip="Copiado"
          triggers="manual"
          #tooltip="ngbTooltip"
          (click)="linkCopy(tooltip)"
        >
          {{ 'copy' | translate }}
        </button>
      </div>
      <share-buttons
        [theme]="'circles-dark'"
        [include]="['facebook', 'messenger', 'whatsapp', 'x', 'email']"
        [showText]="true"
        [url]="url()"
      >
      </share-buttons>
    </div>
  </div>
</mat-dialog-content>
